export default __webpack_public_path__ + "static/media/host-illustration.61bdd795.webp";